import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DatasetDialog, { Field, inputClass, textareaClass, primaryClass, neutralClass } from 'features/datasets/components/DatasetDialog';
import { createDataset } from 'features/datasets/api/datasetsApi';

/**
 * New dataset: a name, and the empty dataset opens. Rows come afterwards, on
 * the dataset page: Add source, Import, Add row, or the SDK (docs/DATASETS.md).
 */
export default function NewDatasetDialog({ onClose, onCreated }) {
  const { team } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const create = async () => {
    const trimmed = name.trim();
    if (!trimmed) { setError('Name the dataset.'); return; }
    setBusy(true); setError(null);
    try {
      const dataset = await createDataset(trimmed, { description: description.trim() || undefined });
      onCreated?.(dataset);
      onClose();
      navigate(`/${encodeURIComponent(team)}/datasets/${dataset.id}`);
    } catch (e) {
      setError(e?.response?.data?.message || e?.response?.data?.error || e.message);
    } finally { setBusy(false); }
  };

  const footer = (
    <>
      <button type="button" onClick={onClose} className={neutralClass}>Cancel</button>
      <button type="submit" disabled={busy || !name.trim()} className={primaryClass}>{busy ? 'Creating…' : 'Create'}</button>
    </>
  );

  return (
    <DatasetDialog title="New dataset" onClose={onClose} footer={footer} onSubmit={create}>
      <Field label="Name" htmlFor="nd-name">
        <input id="nd-name" className={inputClass} value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Billing failures" maxLength={120} autoFocus />{/* eslint-disable-line jsx-a11y/no-autofocus */}
      </Field>
      <Field label="Description" htmlFor="nd-desc">
        <textarea id="nd-desc" rows={2} className={textareaClass} value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Optional" maxLength={2000} />
      </Field>
      {error ? <p className="text-[12px] text-danger">{error}</p> : null}
    </DatasetDialog>
  );
}
